import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { OnChange } from '@df/ng/on-change';
import { BgContrastDirective } from '@df/ui/atomic/atom/color/bg-contrast.directive';
import { IsWhitePipe } from '@df/ui/display/is-white.pipe';

@Component({
    selector: 'swatch',
    templateUrl: './swatch.html',
    styleUrl: './swatch.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [BgContrastDirective, CommonModule, DfImageDirective, IsWhitePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwatchComponent implements OnChanges {
    /**
     * Option related to the color
     */
    option: Catalog.IAttributeOption;

    /**
     * color option id
     */
    @Input()
    @OnChange(function () {
        this.option = this.color ? this.attributeResource.get('color')?.data?.options?.find(i => i.value === this.color) : undefined;
    })
    color: number;

    /**
     * If swatch is selected
     */
    @Input()
    selected = false;

    constructor(
        private attributeResource: AttributeResource,
        private ref: ChangeDetectorRef
    ) {
        this.ref.detach();
    }

    /**
     * Only detect changes on inputs chance
     */
    ngOnChanges() {
        this.ref.detectChanges();
    }
}
